<template>
    <div v-if="team" class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-header>Team Profile</page-header>
        <update-team-details v-model:team="team" :disabled="!props.isTeamAdmin || !onCorporate()"></update-team-details>

        <update-workflow-settings v-if="FEATURES.workflow_builder && onCorporate() && props.isTeamAdmin" :teamId="team.id" />

        <template v-if="onCorporate() && props.impersonator && props.isTeamAdmin">
            <update-groups-use-corporate-numbers v-if="FEATURES.contact_groups" v-model:team="team" />

            <update-team-url :team="team"></update-team-url>
        </template>
    </div>
</template>

<script setup>
import UpdateTeamDetails from './UpdateTeamDetails.vue';
import UpdateWorkflowSettings from './UpdateWorkflowSettings.vue';
import UpdateTeamUrl from './UpdateTeamUrl.vue';
import UpdateGroupsUseCorporateNumbers from './UpdateGroupsUseCorporateNumbers.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import { FEATURES } from '~/provides/features';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const team = defineModel('team', {
    type: Object,
    required: true,
});

const props = defineProps({
    isTeamAdmin: {
        type: Boolean,
    },
    impersonator: {
        type: Boolean,
    }
});

const { onCorporate } = useCurrentGroup();
</script>
